/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  DisplayCatalogSearchResults,
  RetrieveCatalogSearchResultsRequest
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Searches, filters, facets and pages the caller's shop catalog: a batch of searches answered in
order, each scoped to the platform the caller is shopping whatever its filter names. The
in-house replacement for the Algolia multi-query the shop sent from the browser.
 */
export const retrieveCatalogSearchResults = (
    retrieveCatalogSearchResultsRequest: RetrieveCatalogSearchResultsRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayCatalogSearchResults>(
      {url: `/api/v1/catalog-search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: retrieveCatalogSearchResultsRequest, signal
    },
      options);
    }




export const getRetrieveCatalogSearchResultsMutationKey = () => ['retrieveCatalogSearchResults'] as const;

export const getRetrieveCatalogSearchResultsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retrieveCatalogSearchResults>>, TError,RetrieveCatalogSearchResultsMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof retrieveCatalogSearchResults>>, TError,RetrieveCatalogSearchResultsMutationVariables, TContext> => {

const mutationKey = getRetrieveCatalogSearchResultsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retrieveCatalogSearchResults>>, RetrieveCatalogSearchResultsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  retrieveCatalogSearchResults(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetrieveCatalogSearchResultsMutationResult = NonNullable<Awaited<ReturnType<typeof retrieveCatalogSearchResults>>>
    export type RetrieveCatalogSearchResultsMutationBody = RetrieveCatalogSearchResultsRequest
    export type RetrieveCatalogSearchResultsMutationError = ErrorType<void>
    export type RetrieveCatalogSearchResultsMutationVariables = {data: RetrieveCatalogSearchResultsRequest}

    /**
 * @summary Searches, filters, facets and pages the caller's shop catalog: a batch of searches answered in
order, each scoped to the platform the caller is shopping whatever its filter names. The
in-house replacement for the Algolia multi-query the shop sent from the browser.
 */
export const useRetrieveCatalogSearchResults = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retrieveCatalogSearchResults>>, TError,RetrieveCatalogSearchResultsMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retrieveCatalogSearchResults>>,
        TError,
        RetrieveCatalogSearchResultsMutationVariables,
        TContext
      > => {
      return useMutation(getRetrieveCatalogSearchResultsMutationOptions(options), queryClient);
    }
